import { Link } from 'react-router-dom';
import AuthGate from '../../../components/feature/AuthGate';

const HeroSection = () => {
  const scrollToHowItWorks = (e: React.MouseEvent) => {
    e.preventDefault();
    const section = document.getElementById('how-it-works');
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden bg-dark">
      <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHBhdHRlcm4gaWQ9ImdyaWQiIHdpZHRoPSI2MCIgaGVpZ2h0PSI2MCIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHBhdGggZD0iTSAxMCAwIEwgMCAwIDAgMTAiIGZpbGw9Im5vbmUiIHN0cm9rZT0icmdiYSgxNiwgMTg1LCAxMjksIDAuMSkiIHN0cm9rZS13aWR0aD0iMSIvPjwvcGF0dGVybj48L2RlZnM+PHJlY3Qgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgZmlsbD0idXJsKCNncmlkKSIvPjwvc3ZnPg==')] opacity-30"></div>
      
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
        <div className="relative w-[400px] h-[400px]">
          <div className="absolute top-0 left-0 w-48 h-48 bg-emerald/15 rounded-full blur-[100px] animate-pulse-slow"></div>
          <div className="absolute bottom-0 right-0 w-40 h-40 bg-emerald-light/12 rounded-full blur-[100px] animate-pulse-slow" style={{ animationDelay: '1s' }}></div>
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-56 h-56 bg-emerald/8 rounded-full blur-[100px] animate-glow"></div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-24 sm:py-32 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div className="space-y-6 sm:space-y-8 text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 sm:px-4 py-2 rounded-full bg-emerald-dark/20 border border-emerald/30">
              <i className="ri-flashlight-line text-emerald text-base sm:text-lg"></i>
              <span className="text-emerald text-xs sm:text-sm font-medium whitespace-nowrap">Gerçek Zamanlı Algoritmik Kararlar</span>
            </div>

            <h1 className="text-5xl sm:text-6xl lg:text-7xl xl:text-8xl font-black leading-tight">
              <span className="block text-beige-light">Veriyi</span>
              <span className="block text-beige-light">Karara</span>
              <span className="block bg-gradient-to-r from-emerald to-emerald-light bg-clip-text text-transparent">Dönüştür.</span>
            </h1>

            <p className="text-base sm:text-lg lg:text-xl text-beige/70 leading-relaxed max-w-xl mx-auto lg:mx-0">
              BAGA, yüzlerce hissede anlık tarama yapar ve karmaşık verileri sade alım–izleme kararlarına dönüştürür.
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 sm:gap-4">
              <AuthGate>
                {(handleClick) => (
                  <button
                    onClick={handleClick}
                    className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-emerald hover:bg-emerald-light text-beige-light px-6 sm:px-8 py-3 sm:py-4 rounded-full text-sm sm:text-base font-semibold transition-all hover:shadow-lg hover:shadow-emerald/50 hover:scale-105 whitespace-nowrap cursor-pointer"
                  >
                    Canlı Kararları Gör
                    <i className="ri-arrow-right-line text-lg"></i>
                  </button>
                )}
              </AuthGate>
              <a
                href="#how-it-works"
                onClick={scrollToHowItWorks}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-transparent border-2 border-emerald text-emerald hover:bg-emerald/10 px-6 sm:px-8 py-3 sm:py-4 rounded-full text-sm sm:text-base font-semibold transition-all whitespace-nowrap cursor-pointer"
              >
                Nasıl Çalışır?
              </a>
            </div>
          </div>

          <div className="relative mt-8 lg:mt-0">
            <div className="absolute inset-0 bg-gradient-to-r from-emerald/40 to-emerald-light/40 rounded-3xl blur-[80px] animate-glow"></div>
            
            <div className="relative bg-dark-card/80 backdrop-blur-xl rounded-2xl p-4 sm:p-6 lg:p-8 border border-emerald/20 shadow-2xl transform hover:scale-105 transition-transform duration-500">
              <div className="flex items-center justify-between mb-4 sm:mb-6">
                <div className="flex items-center gap-2 sm:gap-3">
                  <div className="w-2.5 h-2.5 sm:w-3 sm:h-3 bg-red-500 rounded-full animate-pulse"></div>
                  <span className="text-xs sm:text-sm font-semibold text-beige/80">CANLI KARARLAR</span>
                </div>
                <span className="text-xs text-beige/50 hidden sm:block">Son güncelleme: 2 sn önce</span>
              </div>

              <div className="space-y-2 sm:space-y-3">
                {[
                  { symbol: 'THYAO', signal: 'ALIM', price: '₺342.50', change: '+2.4%', positive: true },
                  { symbol: 'EREGL', signal: 'İZLE', price: '₺48.75', change: '+0.8%', positive: true },
                  { symbol: 'AKBNK', signal: 'ALIM', price: '₺52.30', change: '+1.2%', positive: true },
                  { symbol: 'TUPRS', signal: 'İZLE', price: '₺125.80', change: '-0.3%', positive: false },
                ].map((item, index) => (
                  <div
                    key={index}
                    className="flex items-center justify-between p-3 sm:p-4 bg-dark-lighter/50 rounded-xl border border-gray-800 hover:border-emerald/30 transition-colors"
                  >
                    <div className="flex items-center gap-2 sm:gap-4">
                      <span className="text-beige-light font-bold text-sm sm:text-base">{item.symbol}</span>
                      <span className={`px-2 sm:px-3 py-1 rounded-full text-xs font-semibold ${
                        item.signal === 'ALIM' 
                          ? 'bg-emerald/20 text-emerald border border-emerald/30' 
                          : 'bg-blue-500/20 text-blue-400 border border-blue-500/30'
                      }`}>
                        {item.signal}
                      </span>
                    </div>
                    <div className="text-right">
                      <div className="text-beige-light font-semibold text-xs sm:text-sm">{item.price}</div>
                      <div className={`text-xs font-medium ${item.positive ? 'text-emerald' : 'text-red-400'}`}>
                        {item.change}
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              <div className="mt-4 sm:mt-6 flex items-center justify-center gap-2 text-xs text-beige/50">
                <i className="ri-information-line"></i>
                <span>Temsili veri gösterimi</span>
              </div>
            </div>

            <div className="absolute -top-8 -right-8 w-32 sm:w-44 h-32 sm:h-44 bg-emerald/20 rounded-full blur-3xl animate-float hidden sm:block"></div>
            <div className="absolute -bottom-8 -left-8 w-40 sm:w-52 h-40 sm:h-52 bg-emerald-light/15 rounded-full blur-3xl animate-float hidden sm:block" style={{ animationDelay: '2s' }}></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
